import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../../components/Auth/AuthLayout';
import LoadingButton from '../../../components/Auth/LoadingButton';

const AirlinerRegistrationSuccessPage = () => {
  const navigate = useNavigate();

  const successIcon = (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
  );

  return (
    <AuthLayout
      title="Registration Successful!"
      subtitle="Your airliner account has been created successfully"
      icon={successIcon}
      iconBgColor="bg-jet-green-100"
      iconColor="text-jet-green-600"
    >
      <div className="text-center space-y-6">
        <div className="bg-jet-green-50 border border-jet-green-200 rounded-lg p-4">
          <h3 className="text-lg font-semibold text-jet-green-900 mb-2">
            Welcome to JetScanner Airliner!
          </h3>
          <p className="text-sm text-jet-green-800">
            Your account has been successfully created and verified. 
            You can now access your airliner management dashboard.
          </p>
        </div>

        <div className="space-y-4">
          <p className="text-jet-gray-600">
            You can now manage your aircraft, flights, routes, and bookings 
            through your personalized dashboard.
          </p>

          <div className="bg-jet-yellow-50 border border-jet-yellow-200 rounded-lg p-4">
            <h4 className="text-sm font-semibold text-jet-yellow-900 mb-2">
              Next Steps:
            </h4>
            <ul className="text-sm text-jet-yellow-800 space-y-1">
              <li>• Complete your airliner profile</li>
              <li>• Add your aircraft fleet</li>
              <li>• Set up flight routes</li>
              <li>• Configure booking settings</li>
            </ul>
          </div>
        </div>

        <div className="space-y-3">
          <LoadingButton
            onClick={() => navigate('/airliner')}
            className="bg-jet-yellow hover:bg-jet-yellow-hover text-jet-gray-900"
          >
            Go to Dashboard
          </LoadingButton>

          <button
            onClick={() => navigate('/airliner/auth/login')}
            className="w-full border border-jet-gray-300 hover:border-jet-gray-400 text-jet-gray-700 font-medium py-3 px-4 rounded-md transition-colors"
          >
            Login Later
          </button>
        </div>

        {/* Back to Main Site */}
        <div className="pt-4 border-t border-jet-gray-200">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="text-jet-gray-600 hover:text-jet-gray-900 text-sm transition-colors"
          >
            ← Back to Main Site
          </button>
        </div>
      </div>
    </AuthLayout>
  );
};

export default AirlinerRegistrationSuccessPage;